import React, { Suspense, lazy } from 'react';
import qs from 'query-string';
import { autobind } from 'core-decorators';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';

import LoadingContainer from 'src/componentes/loading-container';
import history from 'src/history';
import Panel from 'src/componentes/panel';
import ContentManager from 'src/componentes/content-manager';
import http from 'src/services/httpService';
import EditPage from 'src/componentes/edit/edit-page';
import LoadingScreen from 'src/componentes/LoadingScreen';
import PanelCollapse from 'src/componentes/panel-collapse';

import Resumo from './resumo';
import Schema from '../../indicador/schema';
import { capitalizeFirstLetter } from 'src/utils/string';
import { TIPO_ITENS, ADDONS, MODULOS } from 'src/utils/constants';
import MovimentacaoFinanceiraListView from '../../MovimentacaoFinanceira';
import GraficoMovimentacaoFinanceira from '../../MovimentacaoFinanceira/grafico';
import DetalhamentoFinanceiro from 'src/paginas/DetalhamentoFinanceiro';
import {
  getTipoEntidadeComentario,
  buildComentarioDialogTitle,
} from 'src/componentes/comentarios/utils';
import { openComentarioModal } from 'src/componentes/comentarios/ComentarioButton';
import ContextMenuIcon from 'src/componentes/context_menu_icon';
import { DownloadFile, ParseError } from 'src/services/downloadFileUrl';
import errorHandler from 'src/utils/error-handler';
import FichaProjeto from '../../projeto/ficha';
import FichaIndicadorBase from '../../indicador-base/ficha';
import FichaParametroBase from '../../parametro-base/ficha';
import FichaObjetivoEstrategicoBase from '../../objetivo-estrategico-base/ficha';
import FichaDesempenhoIndividual from '../../remuneracao-variavel/desempenho-individual/ficha';
import FichaCalculoIntermediario from '../../remuneracao-variavel/calculo-intermediario/ficha';
import Mensagem from '../../mensagem/modal';
import EmbedPowerBI from '../../power-bi/componentes/power-bi-dialog';
import ModalRelatorioAcompanhamento from '../../relatorio-acompanhamento/modal';
import ModalPlanejamentoInicial from '../../PlanejamentoInicial/view-modal';
// import CenarioListWiew from './cenario';
import AlocacaoRecursosList from 'src/paginas/EscritorioProjetos/alocacaorecursos/lista';

const Desdobramento = lazy(() => import('./desdobramento'));
const Consolidacao = lazy(() => import('./consolidacao'));
const Configuracao = lazy(() => import('./configuracao'));
const Permissoes = lazy(() => import('./permissao'));
const Historico = lazy(() => import('./../../versao-alteracao'));
const StatusReportList = lazy(() => import('../../projeto/status-report'));
const IndicadoresParametros = lazy(() =>
  import('../../projeto/valores/indicadores-parametros')
);
const TermoAbertura = lazy(() => import('./termoabertura'));
const CestaIndicadores = lazy(() => import('./cestaindicadores'));
const TermoEncerramento = lazy(() => import('./termoencerramento'));
const LicoesAprendidasList = lazy(() =>
  import('./termoencerramento/licoesaprendidas')
);
const PMCanvasFullscreen = lazy(() => import('./canvas/PMCanvasFullscreen'));
const ProjetoRiscos = lazy(() =>
  import('../../projeto/projeto-riscos/ProjetoRiscos')
);
const ListAnexos = lazy(() => import('src/paginas/anexos/list'));

let idAtual = null;

@autobind
class ItemEdit extends React.Component {
  static defaultProps = {
    activeTab: 1,
    showDelete: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      saved: false,
      count: 0,
      activeTab: this.props.activeTab,
      modified: false,
      titleItem: '',
      configuracoes: {},
      utilizarPermissoes: true,
      quantidadesMudancasPage: 0,
      permissions: {
        allowEdit: false,
        allowDelete: false,
        allowView: false,
        allowViewPlanejamentoInicial: false,
      },
      canCreateLessons: false,
    };
  }

  componentDidMount() {
    idAtual = this.props.id;
    const tipoId = this.props.tipoId;

    // Verifica se tem permissao para deletar
    this.getPermissions(idAtual);

    // Verificar permissão para criar lições aprendidas
    if (idAtual && tipoId == TIPO_ITENS.PROJETO) {
      this.checkCanCreateLessons(idAtual);
    }

    if (tipoId == 1 || tipoId == 3 || tipoId == 2 || tipoId == 4) {
      http
        .post(
          `/ItemConfiguracao${this.getTipoItem(
            tipoId,
            true
          )}/ObterConfiguracoes`,
          {
            parameters: this.props.parameters,
          }
        )
        .then((response) => {
          this.setState({
            loaded: true,
            isLoading: false,
            configuracoes: response.data,
            utilizarPermissoes:
              response.data && response.data.utilizarPermissoes,
          });
        });
    }
  }

  getPermissions(id) {
    http
      .post(`/Item/GetPermissoesPorId`, {
        id: id,
      })
      .then((response) => {
        if (response.data != null) {
          this.setState({
            permissions: { ...response.data },
          });
        }
      });
  }

  checkCanCreateLessons(itemId) {
    if (!itemId) {
      this.setState({ canCreateLessons: false });
      return;
    }

    http
      .get(`/ItemLicaoAprendidaTermoEncerramento/CanCreate`, {
        params: { itemId: itemId },
      })
      .then((response) => {
        if (response.data != null) {
          this.setState({ canCreateLessons: response.data.canCreate || false });
        }
      })
      .catch(() => {
        this.setState({ canCreateLessons: false });
      });
  }

  componentDidUpdate() {
    if (this.props.id != idAtual) {
      idAtual = this.props.id;
      if (this.state.activeTab != 1) {
        this.setState({
          activeTab: 1,
        });
      }
    }
  }

  handelToggleTab(tab) {
    this.setState({
      quantidadesMudancasPage: this.state.quantidadesMudancasPage + 1,
    });
    this.navigate(tab);
  }

  handleBack() {
    this.handleBackConfirm();
  }

  handleSaveConfirm(tab) {
    this.navigate(tab);
  }

  handleBackConfirm() {
    history.goBack();
  }

  navigate(tab) {
    const queryParams = new URLSearchParams(window.location.search);
    const ehItemRascunho = queryParams.has('ehItemRascunho');

    let search = `?id=${this.props.id}&activeTab=${tab}`;
    if (ehItemRascunho) {
      search = search + '&ehItemRascunho=true';
    }

    history.push({
      pathname: this.props.urlEdit,
      search: search,
    });

    if (this.state.activeTab != tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  getTipoItem(tipoItemId, nomeAbreviado) {
    if (tipoItemId == 1) return 'Indicador';
    else if (tipoItemId == 2) return 'Parametro';
    else if (tipoItemId == 3)
      return nomeAbreviado ? 'Objetivo' : 'ObjetivoEstrategico';
    else if (tipoItemId == TIPO_ITENS.PROJETO) return 'Projeto';
    else if (tipoItemId == 10) return 'DesempenhoIndividual';
    else if (tipoItemId == 11) return 'CalculoIntermediario';
    else if (tipoItemId == 12) return 'TemplateIndicador';
    else if (tipoItemId == 13) return 'TemplateParametro';
    else if (tipoItemId == 14) return 'TemplateObjetivoEstrategico';
    else if (tipoItemId == 15) return 'TemplateProjeto';
  }

  renderContent() {
    let { activeTab } = this.state;
    const { model, addons, intl, modulosComprados } = this.props;

    let tipoItemId = this.props.tipoId;
    let tipoItemString = this.getTipoItem(tipoItemId);
    const ehProjetoEmAprovacao =
      TIPO_ITENS.PROJETO &&
      model.getModel('status') &&
      model.getModel('status').value &&
      (model.getModel('status').value.id == 6 ||
        model.getModel('status').value.id == 7);

    const permitirDigitacaoValores =
      this.props.model.getModel('configuracaoGeral').value &&
      this.props.model.getModel('configuracaoGeral').value
        .permitirDigitacaoValores;

    const ehProjetoConcluidoCancelado =
      TIPO_ITENS.PROJETO &&
      model.getModel('status') &&
      model.getModel('status').value &&
      (model.getModel('status').value.id == 3 ||
        model.getModel('status').value.id == 5);

    const possuiAddonContratosConvenios =
      addons?.find((x) => x.id === ADDONS.CONTRATOS_CONVENIOS && x.ativo) !=
      null;

    const hasEPModule = modulosComprados.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    if (activeTab == 1)
      return (
        <Resumo
          key={this.props.refreshResumo}
          model={this.props.model}
          url={this.props.url}
          schema={this.props.schema}
          id={this.props.id}
          permissions={this.state.permissions}
          onChangeTitle={this.handleChangeTitle}
          changeTab={this.handelToggleTab}
        />
      );
    else if (
      activeTab == 2 &&
      (tipoItemId == 1 || tipoItemId == 2 || tipoItemId == 3)
    )
      return <Desdobramento id={this.props.id} model={this.props.model} />;
    else if (
      activeTab == 3 &&
      (tipoItemId != TIPO_ITENS.PROJETO || permitirDigitacaoValores)
    )
      return (
        <Consolidacao
          disabled={
            this.props.model.getModel('permissions').value
              ? !this.props.model.getModel('permissions').getModel('allowEdit')
                  .value
              : false
          }
          model={this.props.model.getModel('consolidacao')}
          tipoItemId={tipoItemId}
          id={this.props.id}
        />
      );
    else if (
      activeTab == 4 &&
      this.state.utilizarPermissoes &&
      !ehProjetoEmAprovacao
    )
      return (
        <Permissoes
          model={this.props.model}
          id={this.props.id}
          url="/ItemPermissao"
          action="AtualizarTipoAcesso"
          actionPermission="ObterItemPermissions"
          parameters={{
            itemId: this.props.id,
            tipoItemId: tipoItemId,
            url: '/ItemPermissao',
          }}
        />
      );
    else if (activeTab == 5 && !ehProjetoEmAprovacao)
      return (
        <Configuracao
          modelGrafico={this.props.model}
          model={this.props.model.getModel('configuracao')}
          utilizarGestaoMudancas={
            this.props.model.getModel('configuracaoGeral').value &&
            this.props.model.getModel('configuracaoGeral').value
              .utilizarGestaoMudancas
          }
          utilizarValoresPrevios={
            this.props.model.getModel('configuracaoGeral').value &&
            this.props.model.getModel('configuracaoGeral').value
              .utilizarValoresPrevios
          }
          tipoItemId={tipoItemId}
          id={this.props.id}
          exibirCorDoFarol={this.props.exibirCorDoFarol}
        />
      );
    else if (activeTab == 6 && tipoItemId != 10 && tipoItemId != 11)
      return (
        <Panel>
          <Historico
            url={`/${tipoItemString}/ObterHistorico`}
            id={this.props.id}
          />
        </Panel>
      );
    else if (activeTab == 7 && tipoItemId == TIPO_ITENS.PROJETO)
      return (
        <StatusReportList
          url="/ItemPermissao"
          actionPermission="ObterItemPermissions"
          id={this.props.id}
        />
      );
    else if (activeTab == 9 && tipoItemId == TIPO_ITENS.PROJETO)
      return (
        <IndicadoresParametros
          url={`/${tipoItemString}/ObterIndicadoresParametros`}
          id={this.props.id}
        />
      );
    else if (activeTab == 17 && tipoItemId == TIPO_ITENS.PROJETO)
      return (
        <ProjetoRiscos
          projetoId={this.props.id}
          resources={this.props.resources}
        />
      );
    else if (
      activeTab == 18 &&
      (tipoItemId == TIPO_ITENS.PROJETO ||
        tipoItemId == TIPO_ITENS.INDICADOR ||
        tipoItemId == TIPO_ITENS.PARAMETRO ||
        tipoItemId == TIPO_ITENS.OBJETIVO_ESTRATEGICO)
    )
      return (
        <ListAnexos itemId={this.props.id} resources={this.props.resources} />
      );
    else if (
      activeTab == 10 &&
      tipoItemId == TIPO_ITENS.PROJETO &&
      !ehProjetoEmAprovacao
    )
      return <TermoAbertura model={this.props.model} id={this.props.id} />;
    else if (
      activeTab == 11 &&
      (tipoItemId == 1 || tipoItemId == 3 || tipoItemId == 4)
    )
      return <CestaIndicadores itemId={this.props.id} />;
    else if (
      activeTab == 12 &&
      tipoItemId == TIPO_ITENS.PROJETO &&
      ehProjetoConcluidoCancelado
    )
      return <TermoEncerramento model={this.props.model} id={this.props.id} />;
    else if (
      activeTab == 13 &&
      tipoItemId == TIPO_ITENS.PROJETO &&
      possuiAddonContratosConvenios
    )
      return (
        <>
          <Panel
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'movimentacaoFinanceira' })
            )}
          >
            <Row>
              <Col md={12}>
                <GraficoMovimentacaoFinanceira projetoId={this.props.id} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <MovimentacaoFinanceiraListView projetoId={this.props.id} />
              </Col>
            </Row>
          </Panel>
        </>
      );
    else if (activeTab == 14 && tipoItemId == TIPO_ITENS.PROJETO)
      return (
        <Panel>
          <LicoesAprendidasList itemId={this.props.id} />
        </Panel>
      );
    // else if (activeTab == 14 && tipoItemId == TIPO_ITENS.PROJETO && hasEPModule)
    //   return <CenarioListWiew projetoId={this.props.id} />;
    else if (activeTab == 15 && tipoItemId == TIPO_ITENS.PROJETO && hasEPModule)
      return (
        <Panel
          header={intl.formatMessage({
            id: 'detalhamentoFinanceiro',
          })}
        >
          <DetalhamentoFinanceiro projetoId={this.props.id} />
        </Panel>
      );
    else if (activeTab == 16 && tipoItemId == TIPO_ITENS.PROJETO)
      return (
        <Panel
          header={intl.formatMessage({
            id: 'alocacaoRecursos',
          })}
        >
          <AlocacaoRecursosList projetoId={this.props.id} />
        </Panel>
      );
  }

  handleTabAnaliseStakeholders() {
    history.push({
      pathname: '/gerenciar/projeto/analise-stakeholders',
      search: `?id=${this.props.id}`,
    });
  }

  handleTabEAP() {
    history.push({
      pathname: '/acompanhar/eap',
      search: `?itemId=${this.props.id}`,
    });
  }

  handleChangeTitle(titleItem) {
    this.setState({ titleItem });
  }

  openCanvasModal() {
    if (this.canvasModalKey) return;

    this.canvasModalKey = ContentManager.addContent(
      <PMCanvasFullscreen
        model={this.props.model}
        id={this.props.id}
        onClose={() => {
          this.canvasModalKey = null;
        }}
        onSave={() => {
          this.handleCanvasSave();
        }}
      />
    );
  }

  handleCanvasSave() {
    if (this.props.model && this.props.model.getModel) {
      const forceRefreshModel = this.props.model.getModel('forceRefresh');
      if (forceRefreshModel) {
        forceRefreshModel.requestChange(Date.now());
      }
    }
  }

  obterFiltroUrl(item) {
    let { filtro } = this.props;
    let url = '';

    // Filtra o Id do Item
    url = `?itemId=${item.id}`;

    if (filtro != null && filtro != undefined) {
      url += `&openLastFilter=false`;

      // Tipo Filtro Data
      if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0)
        url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;

      // Data Inicio
      if (filtro.dataInicio != null) url += `&dataInicio=${filtro.dataInicio}`;

      // Data Termino
      if (filtro.dataTermino != null)
        url += `&dataTermino=${filtro.dataTermino}`;
    }

    return url;
  }

  handleValueClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/valor',
      search: url,
    });

    this.props.callback && this.props.callback();
    this.props.handleCloseModal && this.props.handleCloseModal();
  }

  getUrlItemExport(item) {
    let urlExportItem = null;

    if (item.tipo && item.tipo.id == TIPO_ITENS.INDICADOR)
      urlExportItem = `/Indicador/ExportResumoIndicador`;
    else if (item.tipo && item.tipo.id == TIPO_ITENS.PROJETO)
      urlExportItem = `/Projeto/ExportResumoPlanoAcao`;

    return urlExportItem;
  }

  handleFichaClick(item) {
    const tipo = item.tipo && item.tipo.id;

    if (tipo === TIPO_ITENS.INDICADOR) {
      ContentManager.addContent(
        <FichaIndicadorBase
          id={item.id}
          obterDadosFichaUrl={`/Indicador/ObterDadosFicha`}
        ></FichaIndicadorBase>
      );
    } else if (tipo === TIPO_ITENS.PARAMETRO) {
      ContentManager.addContent(
        <FichaParametroBase
          id={item.id}
          obterDadosFichaUrl={`/Parametro/ObterDadosFicha`}
        ></FichaParametroBase>
      );
    } else if (tipo === TIPO_ITENS.OBJETIVO_ESTRATEGICO) {
      ContentManager.addContent(
        <FichaObjetivoEstrategicoBase
          id={item.id}
          obterDadosFichaUrl={`/ObjetivoEstrategico/ObterDadosFicha`}
        ></FichaObjetivoEstrategicoBase>
      );
    } else if (tipo === TIPO_ITENS.PROJETO) {
      ContentManager.addContent(<FichaProjeto id={item.id}></FichaProjeto>);
    } else if (tipo === TIPO_ITENS.CALCULO_INTERMEDIARIO) {
      ContentManager.addContent(
        <FichaCalculoIntermediario id={item.id}></FichaCalculoIntermediario>
      );
    } else if (tipo === TIPO_ITENS.DESEMPENHO_INDIVIDUAL) {
      ContentManager.addContent(
        <FichaDesempenhoIndividual id={item.id}></FichaDesempenhoIndividual>
      );
    } else if (tipo === TIPO_ITENS.TEMPLATE_INDICADOR) {
      ContentManager.addContent(
        <FichaIndicadorBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateIndicador/ObterDadosFicha`}
        ></FichaIndicadorBase>
      );
    } else if (tipo == TIPO_ITENS.TEMPLATE_PARAMETRO) {
      ContentManager.addContent(
        <FichaParametroBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateParametro/ObterDadosFicha`}
        ></FichaParametroBase>
      );
    } else if (tipo == TIPO_ITENS.TEMPLATE_OBJETIVO_ESTRATEGICO) {
      ContentManager.addContent(
        <FichaObjetivoEstrategicoBase
          id={item.id}
          obterDadosFichaUrl={`/TemplateObjetivoEstrategico/ObterDadosFicha`}
        ></FichaObjetivoEstrategicoBase>
      );
    }
  }

  handleMensagemClick(item) {
    ContentManager.addContent(<Mensagem fromItem item={{ id: item.id }} />);
  }

  handleRelacionamentosClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/arvore',
      search: url,
    });
  }

  handlePlanoAcaoClick(item) {
    let url = this.obterFiltroUrl(item);

    history.push({
      pathname: '/gerenciar/gantt',
      search: url,
    });
  }

  handleMatrizResponsabilidadesClick(item) {
    history.push({
      pathname: '/acompanhar/matriz-responsabilidades',
      search: `?id=${item.id}`,
    });
  }

  getInternalTabGestaoMudancas(item) {
    const { moduloAtual } = this.props;
    const ehModuloEP = moduloAtual && moduloAtual.id == 7;

    if (item.tipo?.id === TIPO_ITENS.PROJETO) return 1;
    else if (item.tipo?.id === TIPO_ITENS.INDICADOR) {
      if (ehModuloEP) return 2;
      else return 1;
    } else if (item.tipo?.id === TIPO_ITENS.PARAMETRO) {
      if (ehModuloEP) return 3;
      else return 2;
    } else if (item.tipo?.id === TIPO_ITENS.OBJETIVO_ESTRATEGICO) {
      if (ehModuloEP) return 4;
      else return 3;
    }

    if (ehModuloEP) return 2;
    else return 1;
  }

  obterFiltroUrlMatrizResultados(item) {
    let { filtro } = this.props;
    let url = '';

    if (item && item.exibirItensCardMetas) {
      let tipoItemCardMetas = item.tipoItemCardMetas;

      let searchParam =
        tipoItemCardMetas && tipoItemCardMetas.id == 1
          ? `&colaboradorCardMetasId=${item.user.id}&colaboradorCardMetasNome=${item.user.nome}`
          : item.area
          ? `&areaId=${item.area.id}&areaNome=${item.area.nome}`
          : '';

      url = '?exibirItensCardMetas=true';

      url += searchParam;

      if (filtro != null && filtro != undefined) {
        if (filtro.tipoFiltroData != null && filtro.tipoFiltroData.id > 0) {
          url += `&tipoFiltroDataId=${filtro.tipoFiltroData.id}`;
          url += `&tipoFiltroDataDescricao=${filtro.tipoFiltroData.descricao}`;
        }

        if (filtro.dataInicio != null)
          url += `&dataInicio=${filtro.dataInicio}`;

        if (filtro.dataTermino != null)
          url += `&dataTermino=${filtro.dataTermino}`;
      }
    } else {
      url = this.obterFiltroUrl(item);
    }

    return url;
  }

  handleMatrizResultadosClick(item) {
    let url = this.obterFiltroUrlMatrizResultados(item);

    history.push({
      pathname: '/acompanhar/matriz-resultado',
      search: url,
    });
  }

  handleExportClick(item) {
    const urlExportItem = this.getUrlItemExport(item);

    if (urlExportItem != null && item != null)
      http
        .post(
          urlExportItem,
          {
            id: item.id,
          },
          {
            responseType: 'arraybuffer',
          }
        )
        .then((response) => {
          DownloadFile(response);
        })
        .catch((error) => {
          errorHandler(ParseError(error));
        });
  }

  handleRelatorioBIClick(item) {
    http
      .post(`/PowerBI/ObterConfiguracoesPorIndicador`, {
        indicadorID: item.id,
      })
      .then((response) => {
        if (item.desdobramento) {
          response.data.model.campo = null;
        }
        ContentManager.addContent(
          <EmbedPowerBI
            itemId={item.id}
            relatorioPBI={response.data.model.relatorioPBI}
            embedURL={response.data.model.embedURL}
            workspacePBI={response.data.model.workspacePBI}
            filtros={response.data.model.filtros}
            embedToken={response.data.model.embedToken}
            usarAutenticacaoMicrosoft={
              response.data.model.usarAutenticacaoMicrosoft
            }
          />
        );
      })
      .catch((error) => {
        errorHandler(error);
      });
  }

  handleComentarioClick() {
    const tipoEntidade = getTipoEntidadeComentario(this.props.tipoId);
    if (!tipoEntidade) return;

    const tipoId = this.props.tipoId;
    const showTabs =
      tipoId == TIPO_ITENS.INDICADOR ||
      tipoId == TIPO_ITENS.PARAMETRO ||
      tipoId == TIPO_ITENS.OBJETIVO_ESTRATEGICO;

    openComentarioModal({
      tipoEntidade,
      entidadeId: this.props.id,
      quantidadeComentarios: 0,
      dialogTitle: buildComentarioDialogTitle(
        this.props.intl,
        this.state.titleItem || '',
        null
      ),
      item: {
        id: this.props.id,
        tipo: { id: tipoId },
        nome: this.state.titleItem,
        periodicidade: this.props.model.getModel('periodicidade')?.value,
        dataInicioItem: this.props.model.getModel('dataInicioItem')?.value,
        dataTerminoItem: this.props.model.getModel('dataTerminoItem')?.value,
      },
      modalProps: {
        showTabs,
        dataInicio: null,
        dataTermino: null,
      },
    });
  }

  renderMenuItem(
    text,
    onClick,
    isActive = false,
    showNewWindowIcon = false,
    origemClick = null,
    indentado = false
  ) {
    const item = { id: this.props.id, tipo: { id: this.props.tipoId } };

    const needsObterFiltroUrl = [
      'valores',
      'relacionamentos',
      'planoAcao',
      'eap',
    ].includes(origemClick);

    return (
      <ListGroupItem
        action
        className={isActive ? 'active' : ''}
        onClick={onClick}
        style={{
          cursor: 'pointer',
          border: 'none',
          paddingLeft: indentado ? '16px' : '10px',
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          {typeof text === 'string' ? (
            <p
              style={{
                overflowWrap: 'normal',
                textOverflow: 'ellipsis',
                overflowX: 'hidden',
                marginBottom: 'initial',
                flex: 1,
              }}
            >
              {text}
            </p>
          ) : (
            <div style={{ flex: 1 }}>{text}</div>
          )}
          {showNewWindowIcon && origemClick && (
            <div className="ml-2" onClick={(e) => e.stopPropagation()}>
              <ContextMenuIcon
                item={item}
                origemClick={origemClick}
                {...(needsObterFiltroUrl && {
                  obterFiltroUrl: this.obterFiltroUrl,
                })}
                {...(origemClick === 'matrizResultados' && {
                  obterFiltroUrlMatrizResultados:
                    this.obterFiltroUrlMatrizResultados,
                })}
                {...(origemClick === 'gestaoMudancas' && {
                  getInternalTabGestaoMudancas:
                    this.getInternalTabGestaoMudancas,
                })}
              />
            </div>
          )}
        </div>
      </ListGroupItem>
    );
  }

  renderMenuOutrosItens() {
    const { activeTab, configuracoes, permissions } = this.state;
    const { id, tipoId, resources, intl, moduloAtual, model } = this.props;

    const ehProjetoEmAprovacao =
      TIPO_ITENS.PROJETO &&
      model.getModel('status') &&
      model.getModel('status').value &&
      (model.getModel('status').value.id == 6 ||
        model.getModel('status').value.id == 7);

    const permitirDigitacaoValores =
      this.props.model.getModel('configuracaoGeral').value &&
      this.props.model.getModel('configuracaoGeral').value
        .permitirDigitacaoValores;

    const naoEhTemplate =
      tipoId !== TIPO_ITENS.TEMPLATE_INDICADOR &&
      tipoId !== TIPO_ITENS.TEMPLATE_PARAMETRO &&
      tipoId !== TIPO_ITENS.TEMPLATE_OBJETIVO_ESTRATEGICO &&
      tipoId !== TIPO_ITENS.TEMPLATE_PROJETO;

    const exibirPlanoAcao =
      configuracoes &&
      configuracoes.permitirCadastrarAcoes &&
      tipoId !== TIPO_ITENS.PARAMETRO &&
      (naoEhTemplate || tipoId == TIPO_ITENS.TEMPLATE_PROJETO);

    let exibirPowerBI = true;
    exibirPowerBI = exibirPowerBI
      ? permissions
        ? permissions.allowViewPowerBI !== undefined
          ? permissions.allowViewPowerBI
          : true
        : true
      : false;
    if (this.props.usuarioPerfilAdmin) exibirPowerBI = true;
    let exibirValor = naoEhTemplate && tipoId != 6 && tipoId != 5;
    if (tipoId == TIPO_ITENS.PROJETO) {
      exibirValor = permitirDigitacaoValores;
    }
    const exibirRelacionamento =
      tipoId != 12 &&
      tipoId != 13 &&
      tipoId != 14 &&
      tipoId != 15 &&
      tipoId != 17 &&
      naoEhTemplate;
    const exibirFicha = naoEhTemplate && tipoId != 17;
    const exibirMensagem =
      !ehProjetoEmAprovacao && naoEhTemplate && tipoId != 17;
    const exportResumo =
      (tipoId == TIPO_ITENS.PROJETO || tipoId == 1) && naoEhTemplate;
    const exibirRelatorioAcompanhamento =
      (tipoId === 1 || tipoId === 3) && naoEhTemplate;
    const utilizarPlanejamentoInicial =
      configuracoes?.utilizarPlanejamentoInicial &&
      permissions?.allowViewPlanejamentoInicial &&
      naoEhTemplate;

    // Matriz de Resultado: aparece quando item.exibirItensCardMetas é true, de menos pra tipos específicos
    let exibirMatrizResultados = true;
    if (
      tipoId == 6 ||
      tipoId == 5 ||
      tipoId == TIPO_ITENS.PROJETO ||
      tipoId == 12 ||
      tipoId == 13 ||
      tipoId == 14 ||
      tipoId == TIPO_ITENS.TEMPLATE_PROJETO ||
      tipoId == 17
    ) {
      exibirMatrizResultados = false;
    }
    // Verificar se o item tem exibirItensCardMetas do model
    const modelValue = model.getModel().value;
    if (modelValue && modelValue.exibirItensCardMetas) {
      // Se exibirItensCardMetas está true, força exibição
      exibirMatrizResultados = true;
    } else if (modelValue && modelValue.ocultarMenus) {
      exibirMatrizResultados = false;
    }

    let utilizarGestaoMudancas = configuracoes?.utilizarGestaoMudancas || false;
    if (!utilizarGestaoMudancas && configuracoes) {
      if (
        tipoId === TIPO_ITENS.INDICADOR &&
        configuracoes.utilizarGestaoMudancasIndicador
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasIndicador;
      } else if (
        tipoId === TIPO_ITENS.PARAMETRO &&
        configuracoes.utilizarGestaoMudancasParametro
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasParametro;
      } else if (
        tipoId === TIPO_ITENS.OBJETIVO_ESTRATEGICO &&
        configuracoes.utilizarGestaoMudancasObjetivo
      ) {
        utilizarGestaoMudancas = configuracoes.utilizarGestaoMudancasObjetivo;
      }
    }
    // Para tipos 1, 2, 3: exibe se utilizarGestaoMudancas e (não precisa verificar permissões OU tem permissão)
    const exibirGestaoMudancas =
      (tipoId == 1 || tipoId == 2 || tipoId == 3) &&
      utilizarGestaoMudancas &&
      (!permissions || permissions.allowViewGestaoMudancas !== false);

    const utilizarFrst = permissions?.allowViewModuloFrst;

    const temItensAcompanhamento =
      exibirValor ||
      exibirRelacionamento ||
      exibirMatrizResultados ||
      exibirFicha ||
      exibirPowerBI ||
      exibirRelatorioAcompanhamento;

    const temItensPlanejamento =
      exibirPlanoAcao || exibirGestaoMudancas || utilizarPlanejamentoInicial;

    const temItensDetalhamento =
      tipoId == 1 ||
      tipoId == 2 ||
      tipoId == 3 ||
      (tipoId != TIPO_ITENS.PROJETO && tipoId != TIPO_ITENS.TEMPLATE_PROJETO) ||
      permitirDigitacaoValores ||
      (moduloAtual &&
        moduloAtual.id == 3 &&
        (tipoId == 1 || tipoId == 3 || tipoId == 4));

    const temItensConfiguracoes =
      this.state.utilizarPermissoes ||
      !ehProjetoEmAprovacao ||
      (tipoId != 10 && tipoId != 11 && tipoId != 17) ||
      exibirMensagem ||
      exportResumo ||
      tipoId == TIPO_ITENS.INDICADOR ||
      tipoId == TIPO_ITENS.PARAMETRO ||
      tipoId == TIPO_ITENS.OBJETIVO_ESTRATEGICO ||
      utilizarFrst;

    const primeiraSecaoAberta = temItensAcompanhamento
      ? 'acompanhamento'
      : temItensPlanejamento
      ? 'planejamento'
      : temItensDetalhamento
      ? 'detalhamento'
      : temItensConfiguracoes
      ? 'configuracoes'
      : 'acompanhamento';

    return (
      <>
        <ListGroup flush style={{ marginBottom: 0, marginTop: 20 }}>
          <ListGroupItem
            action
            className={activeTab == 1 ? 'active' : ''}
            onClick={() => this.handelToggleTab(1)}
            style={{
              cursor: 'pointer',
              border: 'none',
              paddingLeft: '10px',
              color: activeTab == 1 ? undefined : 'var(--primary)',
              fontWeight: 700,
              fontSize: '16px',
              paddingBottom: 6,
            }}
          >
            {capitalizeFirstLetter(intl.formatMessage({ id: 'label.resumo' }))}
          </ListGroupItem>
        </ListGroup>

        {temItensAcompanhamento && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'acompanhamento' })
            )}
            open={primeiraSecaoAberta === 'acompanhamento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {(tipoId == 17 || exibirValor) &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'valores' },
                      { valores: resources.valores }
                    )
                  ),
                  () => this.handleValueClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  true,
                  'valores',
                  true
                )}
              {exibirRelacionamento &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.relacionamentos),
                  () =>
                    this.handleRelacionamentosClick({
                      id: id,
                      tipo: { id: tipoId },
                    }),
                  false,
                  true,
                  'relacionamentos',
                  true
                )}
              {exibirMatrizResultados &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'matrizderesultados' },
                      { matrizderesultados: resources.matrizderesultados }
                    )
                  ),
                  () => {
                    const item = { id: id, tipo: { id: tipoId } };
                    // Tentar obter exibirItensCardMetas do model se disponível
                    const modelValue = model.getModel().value;
                    if (modelValue && modelValue.exibirItensCardMetas) {
                      item.exibirItensCardMetas =
                        modelValue.exibirItensCardMetas;
                      item.tipoItemCardMetas = modelValue.tipoItemCardMetas;
                      item.user = modelValue.user;
                      item.area = modelValue.area;
                    }
                    this.handleMatrizResultadosClick(item);
                  },
                  false,
                  true,
                  'matrizResultados',
                  true
                )}
              {exibirFicha &&
                this.renderMenuItem(
                  <FormattedMessage
                    id="label.ficha"
                    values={{ ficha: resources.ficha }}
                  />,
                  () => this.handleFichaClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  false,
                  null,
                  true
                )}
              {exibirPowerBI &&
                this.renderMenuItem(
                  <FormattedMessage id="bi" />,
                  () =>
                    this.handleRelatorioBIClick({
                      id: id,
                      tipo: { id: tipoId },
                    }),
                  false,
                  false,
                  null,
                  true
                )}
              {exibirRelatorioAcompanhamento &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.relatoriodeacompanhamento),
                  () => {
                    ContentManager.addContent(
                      <ModalRelatorioAcompanhamento
                        fromItem
                        item={{ id: id, tipo: { id: tipoId } }}
                        filtro={this.props.filtro}
                      />
                    );
                  },
                  false,
                  false,
                  null,
                  true
                )}
            </ListGroup>
          </PanelCollapse>
        )}

        {temItensPlanejamento && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'planejamento' })
            )}
            open={primeiraSecaoAberta === 'planejamento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {exibirPlanoAcao &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.planodeacao),
                  () =>
                    this.handlePlanoAcaoClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  true,
                  'planoAcao',
                  true
                )}
              {exibirGestaoMudancas &&
                this.renderMenuItem(
                  intl.formatMessage(
                    { id: 'gestaoMudancas' },
                    { gestaoMudancas: resources.gestaoMudancas }
                  ),
                  () => {
                    const internalTab =
                      tipoId === TIPO_ITENS.INDICADOR
                        ? moduloAtual && moduloAtual.id == 7
                          ? 2
                          : 1
                        : tipoId === TIPO_ITENS.PARAMETRO
                        ? moduloAtual && moduloAtual.id == 7
                          ? 3
                          : 2
                        : tipoId === TIPO_ITENS.OBJETIVO_ESTRATEGICO
                        ? moduloAtual && moduloAtual.id == 7
                          ? 4
                          : 3
                        : moduloAtual && moduloAtual.id == 7
                        ? 2
                        : 1;
                    history.push({
                      pathname: '/minhas-tarefas/gestao-mudancas',
                      search: `?tab=1&tabInterna=${internalTab}&isNew=true&entityId=${id}`,
                    });
                  },
                  false,
                  true,
                  'gestaoMudancas',
                  true
                )}
              {utilizarPlanejamentoInicial &&
                this.renderMenuItem(
                  <FormattedMessage id="planejamentoInicial" />,
                  () => {
                    ContentManager.addContent(
                      <ModalPlanejamentoInicial
                        fromItem
                        item={{ id: id, tipo: { id: tipoId } }}
                        filtro={this.props.filtro}
                      />
                    );
                  },
                  false,
                  false,
                  null,
                  true
                )}
            </ListGroup>
          </PanelCollapse>
        )}

        {temItensDetalhamento && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'detalhamento' })
            )}
            open={primeiraSecaoAberta === 'detalhamento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {(tipoId == 1 || tipoId == 2 || tipoId == 3) &&
                this.renderMenuItem(
                  <FormattedMessage id="desdobramento" />,
                  () => this.handelToggleTab(2),
                  activeTab == 2,
                  false,
                  null,
                  true
                )}
              {((tipoId != TIPO_ITENS.PROJETO &&
                tipoId != TIPO_ITENS.TEMPLATE_PROJETO) ||
                permitirDigitacaoValores) &&
                this.renderMenuItem(
                  <FormattedMessage id="label.consolidacao" />,
                  () => this.handelToggleTab(3),
                  activeTab == 3,
                  false,
                  null,
                  true
                )}
              {moduloAtual &&
                moduloAtual.id == 3 &&
                (tipoId == 1 || tipoId == 3 || tipoId == 4) &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.cardmetas),
                  () => this.handelToggleTab(11),
                  activeTab == 11,
                  false,
                  null,
                  true
                )}
            </ListGroup>
          </PanelCollapse>
        )}

        {temItensConfiguracoes && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'governancaEControle' })
            )}
            open={primeiraSecaoAberta === 'configuracoes'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {this.state.utilizarPermissoes &&
                tipoId != 12 &&
                tipoId != 13 &&
                tipoId != 14 &&
                tipoId != 15 &&
                tipoId != 17 &&
                !ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  <FormattedMessage id="label.permissoes" />,
                  () => this.handelToggleTab(4),
                  activeTab == 4,
                  false,
                  null,
                  true
                )}
              {!ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  <FormattedMessage id="configuracoes" />,
                  () => this.handelToggleTab(5),
                  activeTab == 5,
                  false,
                  null,
                  true
                )}
              {tipoId != 10 &&
                tipoId != 11 &&
                tipoId != 17 &&
                this.renderMenuItem(
                  <FormattedMessage id="label.historico" />,
                  () => this.handelToggleTab(6),
                  activeTab == 6,
                  false,
                  null,
                  true
                )}
              {(tipoId == TIPO_ITENS.INDICADOR ||
                tipoId == TIPO_ITENS.PARAMETRO ||
                tipoId == TIPO_ITENS.OBJETIVO_ESTRATEGICO) &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'label.anexos' })
                  ),
                  () => this.handelToggleTab(18),
                  activeTab == 18,
                  false,
                  null,
                  true
                )}
              {(tipoId == TIPO_ITENS.INDICADOR ||
                tipoId == TIPO_ITENS.PARAMETRO ||
                tipoId == TIPO_ITENS.OBJETIVO_ESTRATEGICO) &&
                this.renderMenuItem(
                  <FormattedMessage id="label.comentarios" />,
                  () => this.handleComentarioClick(),
                  false,
                  false,
                  null,
                  true
                )}
              {exibirMensagem &&
                this.renderMenuItem(
                  <FormattedMessage id="label.mensagens" />,
                  () =>
                    this.handleMensagemClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  false,
                  null,
                  true
                )}
              {exportResumo &&
                this.renderMenuItem(
                  <FormattedMessage id="label.exportarPDF" />,
                  () =>
                    this.handleExportClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  false,
                  null,
                  true
                )}
              {utilizarFrst &&
                this.renderMenuItem(
                  <span>FRST</span>,
                  () => {
                    import('src/componentes/AcessarFrstClick').then(
                      ({ acessarFrstClick }) => {
                        acessarFrstClick(intl);
                      }
                    );
                  },
                  false,
                  false,
                  null,
                  true
                )}
            </ListGroup>
          </PanelCollapse>
        )}
      </>
    );
  }

  renderMenuProjetos() {
    const { activeTab, configuracoes, permissions } = this.state;
    const {
      id,
      tipoId,
      resources,
      intl,
      moduloAtual,
      model,
      addons,
      modulosComprados,
    } = this.props;

    const ehProjetoEmAprovacao =
      TIPO_ITENS.PROJETO &&
      model.getModel('status') &&
      model.getModel('status').value &&
      (model.getModel('status').value.id == 6 ||
        model.getModel('status').value.id == 7);

    const permitirDigitacaoValores =
      this.props.model.getModel('configuracaoGeral').value &&
      this.props.model.getModel('configuracaoGeral').value
        .permitirDigitacaoValores;

    //* Desenvolvido para licitação, será comentado para, caso necessário, ser usado novamente
    // const utilizarDetalhamentoFinanceiro =
    //   this.props.model.getModel('configuracaoGeral').value &&
    //   this.props.model.getModel('configuracaoGeral').value
    //     .utilizarDetalhamentoFinanceiro;

    const ehProjetoConcluidoCancelado =
      TIPO_ITENS.PROJETO &&
      model.getModel('status') &&
      model.getModel('status').value &&
      (model.getModel('status').value.id == 3 ||
        model.getModel('status').value.id == 5);

    const possuiAddonContratosConvenios =
      addons?.find((x) => x.id === ADDONS.CONTRATOS_CONVENIOS && x.ativo) !=
      null;

    const hasEPModule = modulosComprados.find(
      (m) => m.id === MODULOS.ESCRITORIO_PROJETOS && m.ativo
    );

    let utilizaAnaliseStakeholders =
      this.props.model.getModel('configuracaoGeral').value &&
      this.props.model.getModel('configuracaoGeral').value
        .utilizarAnaliseStakeholders;

    let exibirPowerBI = true;
    exibirPowerBI = exibirPowerBI
      ? permissions
        ? permissions.allowViewPowerBI !== undefined
          ? permissions.allowViewPowerBI
          : true
        : true
      : false;
    if (this.props.usuarioPerfilAdmin) exibirPowerBI = true;

    const utilizarGestaoMudancas =
      configuracoes?.utilizarGestaoMudancas || false;

    const exibirGestaoMudancas =
      moduloAtual &&
      moduloAtual.id == 7 &&
      utilizarGestaoMudancas &&
      (!permissions || permissions.allowViewGestaoMudancas !== false);

    const utilizarAlocacaoRecursos =
      configuracoes?.utilizarAlocacaoRecursos || false;

    const exibirAlocacaoRecursos =
      moduloAtual &&
      moduloAtual.id == 7 &&
      utilizarAlocacaoRecursos &&
      (!permissions || permissions.allowViewAlocacaoRecursos !== false);

    const temItensIniciacao =
      moduloAtual && moduloAtual.id == 7 && !ehProjetoEmAprovacao;

    const temItensPlanejamento =
      (moduloAtual && moduloAtual.id == 7) ||
      exibirGestaoMudancas ||
      exibirAlocacaoRecursos ||
      hasEPModule ||
      configuracoes?.permitirCadastrarAcoes ||
      (moduloAtual && moduloAtual.id == 7 && !ehProjetoEmAprovacao) ||
      permitirDigitacaoValores ||
      !ehProjetoEmAprovacao;

    const temItensExecucaoMonitoramento =
      !ehProjetoEmAprovacao ||
      exibirPowerBI ||
      (moduloAtual && moduloAtual.id == 1 && possuiAddonContratosConvenios);

    const primeiraSecaoAberta = temItensIniciacao
      ? 'iniciacao'
      : temItensPlanejamento
      ? 'planejamento'
      : temItensExecucaoMonitoramento
      ? 'execucaoMonitoramento'
      : ehProjetoConcluidoCancelado
      ? 'encerramento'
      : 'governancaControle';

    return (
      <>
        <ListGroup flush style={{ marginBottom: 0, marginTop: 20 }}>
          <ListGroupItem
            action
            className={activeTab == 1 ? 'active' : ''}
            onClick={() => this.handelToggleTab(1)}
            style={{
              cursor: 'pointer',
              border: 'none',
              paddingLeft: '10px',
              color: activeTab == 1 ? undefined : 'var(--primary)',
              fontWeight: 700,
              fontSize: '16px',
              paddingBottom: 6,
            }}
          >
            {capitalizeFirstLetter(intl.formatMessage({ id: 'label.resumo' }))}
          </ListGroupItem>
        </ListGroup>

        {temItensIniciacao && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'iniciacao' })
            )}
            open={primeiraSecaoAberta === 'iniciacao'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {moduloAtual && moduloAtual.id == 7 && !ehProjetoEmAprovacao && (
                <>
                  {this.renderMenuItem(
                    capitalizeFirstLetter(resources.tap),
                    () => this.handelToggleTab(10),
                    activeTab == 10,
                    false,
                    null,
                    true
                  )}
                  {this.renderMenuItem(
                    capitalizeFirstLetter(intl.formatMessage({ id: 'canvas' })),
                    () => this.openCanvasModal(),
                    false,
                    false,
                    null,
                    true
                  )}
                  {utilizaAnaliseStakeholders &&
                    this.renderMenuItem(
                      capitalizeFirstLetter(
                        intl.formatMessage({ id: 'analiseStakeholders' })
                      ),
                      () => this.handleTabAnaliseStakeholders(),
                      false,
                      false,
                      null,
                      true
                    )}
                  {!ehProjetoEmAprovacao &&
                    this.renderMenuItem(
                      <FormattedMessage
                        id="label.ficha"
                        values={{ ficha: resources.ficha }}
                      />,
                      () =>
                        this.handleFichaClick({ id: id, tipo: { id: tipoId } }),
                      false,
                      false,
                      null,
                      true
                    )}
                </>
              )}
            </ListGroup>
          </PanelCollapse>
        )}

        {temItensPlanejamento && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'planejamento' })
            )}
            open={primeiraSecaoAberta === 'planejamento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {moduloAtual &&
                moduloAtual.id == 7 &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'eapGrafica' })
                  ),
                  () => this.handleTabEAP(),
                  false,
                  true,
                  'eap',
                  true
                )}
              {hasEPModule &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'matrizResponsabilidades' })
                  ),
                  () =>
                    this.handleMatrizResponsabilidadesClick({
                      id: id,
                      tipo: { id: tipoId },
                    }),
                  false,
                  true,
                  'matrizResponsabilidades',
                  true
                )}
              {!ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.planodeacao),
                  () =>
                    this.handlePlanoAcaoClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  true,
                  'planoAcao',
                  true
                )}
              {exibirGestaoMudancas &&
                this.renderMenuItem(
                  intl.formatMessage(
                    { id: 'gestaoMudancas' },
                    { gestaoMudancas: resources.gestaoMudancas }
                  ),
                  () => {
                    const internalTab = 1;
                    history.push({
                      pathname: '/minhas-tarefas/gestao-mudancas',
                      search: `?tab=1&tabInterna=${internalTab}&isNew=true&entityId=${id}`,
                    });
                  },
                  false,
                  true,
                  'gestaoMudancas',
                  true
                )}
              {exibirAlocacaoRecursos &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'alocacaoRecursos' })
                  ),
                  () => this.handelToggleTab(16),
                  activeTab == 16,
                  false,
                  null,
                  true
                )}
              {moduloAtual &&
                moduloAtual.id == 7 &&
                !ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'indicadoresEParametros' })
                  ),
                  () => this.handelToggleTab(9),
                  activeTab == 9,
                  false,
                  null,
                  true
                )}
              {moduloAtual &&
                moduloAtual.id == 7 &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.riscos),
                  () => this.handelToggleTab(17),
                  activeTab == 17,
                  false,
                  null,
                  true
                )}
              {permitirDigitacaoValores &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage(
                      { id: 'valores' },
                      { valores: resources.valores }
                    )
                  ),
                  () => this.handleValueClick({ id: id, tipo: { id: tipoId } }),
                  false,
                  true,
                  'valores',
                  true
                )}
              {/* {tipoId == TIPO_ITENS.PROJETO && hasEPModule && (
                    <ListGroupItem
                      action
                      className={activeTab == 14 ? 'active' : ''}
                      onClick={() => {
                        this.handelToggleTab(14);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {capitalizeFirstLetter(
                        intl.formatMessage({ id: 'cenarios' })
                      )}
                    </ListGroupItem>
                  )} */}
              {/* Desenvolvido para licitação, será comentado para, caso necessário, ser usado novamente
                  {hasEPModule &&
                    utilizarDetalhamentoFinanceiro &&
                    tipoId == TIPO_ITENS.PROJETO && (
                      <ListGroupItem
                        action
                        className={activeTab == 15 ? 'active' : ''}
                        onClick={() => {
                          this.handelToggleTab(15);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {capitalizeFirstLetter(
                          intl.formatMessage({ id: 'detalhamentoFinanceiro' })
                        )}
                      </ListGroupItem>
                    )} */}
            </ListGroup>
          </PanelCollapse>
        )}

        {temItensExecucaoMonitoramento && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'execucaoEMonitoramento' })
            )}
            open={primeiraSecaoAberta === 'execucaoMonitoramento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {!ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.statusreport),
                  () => this.handelToggleTab(7),
                  activeTab == 7,
                  false,
                  null,
                  true
                )}
              {!ehProjetoEmAprovacao &&
                this.state.canCreateLessons &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'licoesAprendidas' })
                  ),
                  () => this.handelToggleTab(14),
                  activeTab == 14,
                  false,
                  null,
                  true
                )}
              {!ehProjetoEmAprovacao &&
                this.renderMenuItem(
                  capitalizeFirstLetter(resources.relacionamentos),
                  () =>
                    this.handleRelacionamentosClick({
                      id: id,
                      tipo: { id: tipoId },
                    }),
                  false,
                  true,
                  'relacionamentos',
                  true
                )}
              {exibirPowerBI &&
                this.renderMenuItem(
                  <FormattedMessage id="bi" />,
                  () =>
                    this.handleRelatorioBIClick({
                      id: id,
                      tipo: { id: tipoId },
                    }),
                  false,
                  false,
                  null,
                  true
                )}
              {moduloAtual &&
                moduloAtual.id == 1 &&
                possuiAddonContratosConvenios &&
                this.renderMenuItem(
                  capitalizeFirstLetter(
                    intl.formatMessage({ id: 'movimentacaoFinanceira' })
                  ),
                  () => this.handelToggleTab(13),
                  activeTab == 13,
                  false,
                  null,
                  true
                )}
            </ListGroup>
          </PanelCollapse>
        )}

        {ehProjetoConcluidoCancelado && (
          <PanelCollapse
            header={capitalizeFirstLetter(
              intl.formatMessage({ id: 'labelEncerramento' })
            )}
            open={primeiraSecaoAberta === 'encerramento'}
            ehAccordionDrawer={true}
            styleTitle={{ paddingLeft: 10 }}
          >
            <ListGroup flush>
              {this.renderMenuItem(
                capitalizeFirstLetter(
                  intl.formatMessage({ id: 'termoEncerramento' })
                ),
                () => this.handelToggleTab(12),
                activeTab == 12,
                false,
                null,
                true
              )}
            </ListGroup>
          </PanelCollapse>
        )}

        <PanelCollapse
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'governancaEControle' })
          )}
          open={primeiraSecaoAberta === 'governancaControle'}
          ehAccordionDrawer={true}
          styleTitle={{ paddingLeft: 10 }}
        >
          <ListGroup flush>
            {permitirDigitacaoValores &&
              this.renderMenuItem(
                <FormattedMessage id="label.consolidacao" />,
                () => this.handelToggleTab(3),
                activeTab == 3,
                false,
                null,
                true
              )}
            {this.state.utilizarPermissoes &&
              !ehProjetoEmAprovacao &&
              this.renderMenuItem(
                <FormattedMessage id="label.permissoes" />,
                () => this.handelToggleTab(4),
                activeTab == 4,
                false,
                null,
                true
              )}
            {this.renderMenuItem(
              capitalizeFirstLetter(intl.formatMessage({ id: 'label.anexos' })),
              () => this.handelToggleTab(18),
              activeTab == 18,
              false,
              null,
              true
            )}
            {this.renderMenuItem(
              <FormattedMessage id="label.comentarios" />,
              () => this.handleComentarioClick(),
              false,
              false,
              null,
              true
            )}
            {this.renderMenuItem(
              <FormattedMessage id="label.exportarPDF" />,
              () => this.handleExportClick({ id: id, tipo: { id: tipoId } }),
              false,
              false,
              null,
              true
            )}
            {!ehProjetoEmAprovacao &&
              this.renderMenuItem(
                <FormattedMessage id="label.mensagens" />,
                () =>
                  this.handleMensagemClick({ id: id, tipo: { id: tipoId } }),
                false,
                false,
                null,
                true
              )}
            {!ehProjetoEmAprovacao &&
              this.renderMenuItem(
                <FormattedMessage id="configuracoes" />,
                () => this.handelToggleTab(5),
                activeTab == 5,
                false,
                null,
                true
              )}
            {this.renderMenuItem(
              <FormattedMessage id="label.historico" />,
              () => this.handelToggleTab(6),
              activeTab == 6,
              false,
              null,
              true
            )}
          </ListGroup>
        </PanelCollapse>
      </>
    );
  }
  render() {
    const { tipoId } = this.props;

    const ehProjeto = tipoId == TIPO_ITENS.PROJETO;

    return (
      <Suspense fallback={<LoadingScreen />}>
        <div style={{ marginTop: 15 }}>
          <Row>
            <Col md={4} lg={3}>
              <Panel>
                <div
                  style={{
                    maxHeight: 'calc(100vh - 200px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    paddingRight: '8px',
                    marginRight: '-8px',
                  }}
                >
                  {ehProjeto
                    ? this.renderMenuProjetos()
                    : this.renderMenuOutrosItens()}
                </div>
              </Panel>
            </Col>
            <Col Col lg={9} md={8}>
              <LoadingContainer isLoading={this.state.isLoading}>
                {this.renderContent()}
              </LoadingContainer>
            </Col>
          </Row>
        </div>
      </Suspense>
    );
  }
}

class Edit extends React.Component {
  handleClose() {
    const queryParams = new URLSearchParams(window.location.search);
    const ehItemRascunho = queryParams.has('ehItemRascunho');

    if (ehItemRascunho) {
      history.push('/minhas-tarefas/negociacao-metas?activeTab=2');
    } else {
      history.push(this.urlList);
    }
  }

  render() {
    let { location, showPrompt, activeTab } = this.props; //
    let id = location && qs.parse(location.search).id;

    return (
      <EditPage
        title="teste"
        titleField="nome"
        url="/Item"
        formComponent={ItemEdit}
        schema={Schema}
        showTopToolbar={true}
        id={id}
        handleCloseCustom={this.handleClose}
        showPrompt={showPrompt}
        {...this.props}
        showButtonSave={activeTab != 10 && activeTab != 12 && activeTab != 17}
        showDelete={activeTab != 10 && activeTab != 12 && activeTab != 17}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloAtual: state.user.moduloAtual,
    addons: state.user.addonsDisponiveis,
    modulosComprados: state.user.licenca.modulos,
    usuarioPerfilAdmin: state.user.usuarioPerfilAdmin,
  };
}
export default injectIntl(connect(mapStateToProps)(Edit));
